import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ThemeProps } from './types';

const styles = ({ theme: lightOrDarkVersion }: ThemeProps) => {
  const darkColor = theme.colors.neutral90;

  const background = lightOrDarkVersion === 'dark' ? darkColor : theme.colors.white;
  const borderRadius = theme.borderRadius.medium;
  const color = lightOrDarkVersion === 'dark' ? theme.colors.white : darkColor;
  const disabledTextColor = theme.colors.text.disabled;
  const hoverAndFocusBackgroundColor = theme.colors.neutral5;
  const hoverAndFocusTextColor = theme.colors.neutral80;
  const selectedBackgroundColor = theme.colors.text.interactive;
  const selectedTextColor = theme.colors.white;
  const spacing = theme.spacing;
  const subduedColor = theme.colors.text.subdued;

  return css`
    background: ${background};
    border-radius: ${borderRadius};
    color: ${color};
    padding: ${spacing(3)};
    width: fit-content;

    .week-view-heading {
      text-align: center;
      margin-bottom: ${spacing(2)};
    }

    .week-day-bar {
      align-items: center;
      display: flex;
      gap: ${spacing(1)};

      .week-day-list {
        display: flex;
        flex-wrap: wrap;
        gap: ${spacing(1)};
        justify-content: center;

        .week-day-item {
          align-items: center;
          border-radius: ${borderRadius};
          cursor: pointer;
          display: flex;
          flex-direction: column;
          min-width: ${spacing(6)};
          overflow: hidden;
          padding: ${spacing(1)};
          transition: background-color 200ms ease-in-out, color 200ms ease-in-out;
          width: ${spacing(6)};

          &:focus,
          &:hover {
            background: ${hoverAndFocusBackgroundColor};
            color: ${hoverAndFocusTextColor};
            outline: none;
          }

          &.selected,
          &[aria-selected='true'] {
            background-color: ${selectedBackgroundColor};
            color: ${selectedTextColor};
          }

          &.disabled {
            color: ${disabledTextColor};
            pointer-events: none;
          }

          &.pre-selected {
            box-shadow: 0 0 0 1px ${disabledTextColor};
          }

          span {
            color: inherit;
          }
        }
      }
    }

    .time-bar {
      align-items: center;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: ${spacing(4)};

      > div {
        max-width: ${spacing(18)};
      }

      @media screen and (min-width: ${spacing(60)}) {
        flex-direction: row;
        gap: ${spacing(3)};

        > p {
          margin-top: ${spacing(1)};
        }
      }
    }

    .action-bar {
      align-items: center;
      display: flex;
      gap: ${spacing(2)};
      justify-content: flex-end;
      margin-top: ${spacing(5)};

      button {
        width: auto;
      }

      p {
        color: ${subduedColor};
        margin: 0;
      }
    }
  `;
};

export const WeekViewDatePickerStyles = {
  weekViewDatePicker: (props: ThemeProps) => styles(props),
};
